"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uhg = void 0;
var _modifyDomain = require("../../modifyDomain");
var ABYSS_CDN = (0, _modifyDomain.modifyDomain)('https://abyss-cloud.uhg.com/cdn/assets');
var uhg = {
  theme: {
    colors: {
      // primary
      primary1: '#003C71',
      primary2: '#FFFFFF',
      // secondary
      secondary1: '#00BED5',
      secondary2: '#F5B700',
      secondary3: '#FF6814',
      // accent
      accent1: '#E40046',
      accent2: '#0066F5',
      // interactive
      interactive1: '#196ECF',
      interactive2: '#0C55B8',
      interactive3: '#D9E9FA',
      // tints
      tint1: '#FAFCFF',
      tint2: '#E5F8FB',
      tint3: '#CCF2F7',
      tint4: '#99E5EE',
      // supporting
      supporting1: '#422C88',
      supporting2: '#8061BC',
      supporting3: '#007C89',
      supporting4: '#6FC1B1',
      supporting5: '#A32A2E',
      supporting6: '#D13F44',
      // status
      success1: '#007000',
      success2: '#F2F8E6',
      error1: '#C40000',
      error2: '#FCF0F0',
      warning1: '#C24E14',
      warning2: '#FFFBEB',
      info1: '#196ECF',
      info2: '#EDF3FB',
      // --------components --------

      // tabs
      tabBackground: '$tint1',
      // icon
      iconButtonHover: '$interactive3',
      // select input multi
      selectedOption: '$tint2',
      // button
      buttonOutlineHover: '$interactive3',
      // close icon button
      closeIconHover: '$tint2',
      // footer
      footerBackground: '$primary1',
      footerText: '$primary2',
      footerLinkHover: '$primary2',
      footerBorder: '$primary2',
      // toggle tabs
      toggleTabsSelected: '$interactive1',
      // carousel
      carouselControlsDefault: '$gray1',
      carouselControlsWhite: '$gray1',
      carouselControlsPrimary: '$gray1',
      carouselControlsSecondary: '$gray1',
      carouselContentDefault: '$gray3',
      carouselContentWhite: '$white',
      carouselContentPrimary: '$primary1',
      carouselContentSecondary: '#0066F5',
      carouselButtonDefault: '$primary1',
      carouselButtonWhite: '$accent1',
      carouselButtonPrimary: '$white',
      carouselButtonSecondary: '$white',
      // loading spinner
      loadingSpinnerPrimary1: '#003C71',
      // Avatar color themes
      avatarContentAquaBgc: '$tint2',
      avatarContentMintBgc: '$success2',
      avatarContentPeachBgc: '$warning2',
      avatarContentBlueBgc: '$info2',
      avatarContentAquaBorderColor: '$primary1',
      avatarContentMintBorderColor: '$supporting3',
      avatarContentPeachBorderColor: '$supporting5',
      avatarContentBlueBorderColor: '$primary1'
    },
    fonts: {
      primary: 'AbyssGraphik, Arial, sans-serif',
      heading: 'AbyssGraphik, Arial, sans-serif'
    },
    fontWeights: {
      footerFontWeight: '$fontWeightBold',
      dropDownButtonFontWeight: '$medium',
      dropDownMenuFontWeight: '$normal',
      toggleTabsFontWeight: '$medium',
      toolTipFontWeight: '$normal',
      indicatorFontWeight: '$semibold'
    }
  },
  css: {
    '@font-face': [{
      'font-family': 'AbyssGraphik',
      'font-weight': 300,
      'font-style': 'normal',
      'font-display': 'swap',
      src: ["url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-Light.woff2') format('woff2')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-Light.woff') format('woff')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-Light.ttf') format('truetype')")]
    }, {
      'font-family': 'AbyssGraphik',
      'font-weight': 300,
      'font-style': 'italic',
      'font-display': 'swap',
      src: ["url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-LightItalic.woff2') format('woff2')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-LightItalic.woff') format('woff')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-LightItalic.ttf') format('truetype')")]
    }, {
      'font-family': 'AbyssGraphik',
      'font-weight': 'normal',
      'font-style': 'normal',
      'font-display': 'swap',
      src: ["url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-Regular.woff2') format('woff2')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-Regular.woff') format('woff')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-Regular.ttf') format('truetype')")]
    }, {
      'font-family': 'AbyssGraphik',
      'font-weight': 'normal',
      'font-style': 'italic',
      'font-display': 'swap',
      src: ["url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-RegularItalic.woff2') format('woff2')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-RegularItalic.woff') format('woff')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-RegularItalic.ttf') format('truetype')")]
    }, {
      'font-family': 'AbyssGraphik',
      'font-weight': 500,
      'font-style': 'normal',
      'font-display': 'swap',
      src: ["url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-Medium.woff2') format('woff2')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-Medium.woff') format('woff')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-Medium.ttf') format('truetype')")]
    }, {
      'font-family': 'AbyssGraphik',
      'font-weight': 500,
      'font-style': 'italic',
      'font-display': 'swap',
      src: ["url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-MediumItalic.woff2') format('woff2')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-MediumItalic.woff') format('woff')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-MediumItalic.ttf') format('truetype')")]
    }, {
      'font-family': 'AbyssGraphik',
      'font-weight': 700,
      'font-style': 'normal',
      'font-display': 'swap',
      src: ["url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-SemiBold.woff2') format('woff2')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-SemiBold.woff') format('woff')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-SemiBold.ttf') format('truetype')")]
    }, {
      'font-family': 'AbyssGraphik',
      'font-weight': 700,
      'font-style': 'italic',
      'font-display': 'swap',
      src: ["url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-SemiBoldItalic.woff2') format('woff2')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-SemiBoldItalic.woff') format('woff')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-SemiBoldItalic.ttf') format('truetype')")]
    }, {
      'font-family': 'AbyssGraphik',
      'font-weight': 800,
      'font-style': 'normal',
      'font-display': 'swap',
      src: ["url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-Bold.woff2') format('woff2')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-Bold.woff') format('woff')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-Bold.ttf') format('truetype')")]
    }, {
      'font-family': 'AbyssGraphik',
      'font-weight': 800,
      'font-style': 'italic',
      'font-display': 'swap',
      src: ["url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-BoldItalic.woff2') format('woff2')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-BoldItalic.woff') format('woff')"), "url('".concat(ABYSS_CDN, "/uhg/fonts/Graphik/Graphik-BoldItalic.ttf') format('truetype')")]
    }]
  }
};
exports.uhg = uhg;